var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import ProgressCategories from "./ProgressCategories";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faPhone } from "@fortawesome/pro-solid-svg-icons";
import { useFlow } from "../../hooks/df";
import { normalizePhone, runFTLTLogic } from "../../services/dfUtils";
export default function LeftNavHeader() {
    var _this = this;
    var _a, _b;
    var flow = useFlow();
    var parentPage = flow.config.parentPageCollection;
    var _c = useState(false), isOpen = _c[0], setIsOpen = _c[1];
    var _d = useState((parentPage === null || parentPage === void 0 ? void 0 : parentPage.defaultPhone) || ""), phoneNumber = _d[0], setPhoneNumber = _d[1];
    var _e = useState(window.innerWidth <= 768), isMobile = _e[0], setIsMobile = _e[1];
    var getTelHref = function (num) { return num.replace(/\D/g, ""); };
    // Phone Display Logic
    var updatePhoneDisplay = function () { return __awaiter(_this, void 0, void 0, function () {
        var res, pos, result_1, agent, response, agents, _a, storedNum;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!(document.referrer && document.referrer.includes("/mortgage-loans"))) return [3 /*break*/, 7];
                    res = document.referrer.split("/");
                    pos = res.indexOf("mortgage-loans");
                    result_1 = res[pos + 1];
                    if (!result_1) return [3 /*break*/, 7];
                    agent = (_b = window.Agents) === null || _b === void 0 ? void 0 : _b.find(function (a) { return a.agentPageName.toLowerCase() === result_1.toLowerCase(); });
                    if (!!agent) return [3 /*break*/, 6];
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 5, , 6]);
                    return [4 /*yield*/, fetch("/Search/lo/".concat(encodeURIComponent(result_1)))];
                case 2:
                    response = _c.sent();
                    if (!response.ok) return [3 /*break*/, 4];
                    return [4 /*yield*/, response.json()];
                case 3:
                    agents = _c.sent();
                    agent = agents.find(function (a) { return a.agentPageName.toLowerCase() === result_1.toLowerCase(); });
                    _c.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    _a = _c.sent();
                    return [3 /*break*/, 6];
                case 6:
                    if (agent) {
                        if (!localStorage.getItem("phoneDisplayglobal")) {
                            localStorage.setItem("phoneDisplayglobal", (parentPage === null || parentPage === void 0 ? void 0 : parentPage.defaultPhone) || "");
                        }
                        localStorage.setItem("phoneDisplay", agent.mobilePhoneNumber);
                        setPhoneNumber(normalizePhone(agent.mobilePhoneNumber));
                        return [2 /*return*/];
                    }
                    _c.label = 7;
                case 7:
                    storedNum = localStorage.getItem("phoneDisplay");
                    if (storedNum) {
                        setPhoneNumber(normalizePhone(storedNum));
                    }
                    else if (parentPage === null || parentPage === void 0 ? void 0 : parentPage.defaultPhone) {
                        setPhoneNumber(parentPage.defaultPhone);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (parentPage === null || parentPage === void 0 ? void 0 : parentPage.defaultPhone) {
            setPhoneNumber(parentPage.defaultPhone);
        }
    }, [parentPage]);
    useEffect(function () {
        runFTLTLogic();
        void updatePhoneDisplay();
        var handleResize = function () {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener("resize", handleResize);
        return function () { return window.removeEventListener("resize", handleResize); };
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx("header", { className: "hd", children: _jsxs("div", { className: "row g-3 g-sm-0 align-items-center justify-content-between justify-content-md-end", children: [_jsx("div", { className: "col-auto d-md-none", children: _jsx("button", { className: "btn-menu", "aria-label": "Open menu", onClick: function () { return setIsOpen(true); }, children: _jsx(FontAwesomeIcon, { icon: faBars }) }) }), _jsx("div", { className: "col d-md-none", children: _jsx("div", { className: "hd-logo", children: _jsx("a", { href: "/", children: _jsx("img", { src: "https://assets.newamericanfunding.com/images/logos/logo-new-american-funding.svg", alt: "New American Funding logo" }) }) }) }), _jsx("div", { className: "col-auto", children: _jsxs("a", { className: "hd-phone", href: "tel:".concat(getTelHref(phoneNumber)), "aria-label": "Call New American Funding at ".concat(normalizePhone(phoneNumber)), children: [_jsx(FontAwesomeIcon, { icon: faPhone, "aria-hidden": "true" }), _jsx("span", { className: "hd-phone-text d-none d-md-inline-block", children: normalizePhone(phoneNumber) }), _jsx("span", { className: "visually-hidden d-md-none", children: normalizePhone(phoneNumber) })] }) })] }) }), _jsx("div", { id: "overlay", className: "overlay ".concat(isOpen ? "show" : ""), style: { display: isOpen ? "block" : "none" }, children: _jsxs("div", { className: "overlay-content", children: [_jsx("button", { className: "btn-close", onClick: function () { return setIsOpen(false); }, "aria-label": "Close Navigation" }), _jsx(ProgressCategories, { activeSlide: flow.currentStep, navGroups: (_b = (_a = flow === null || flow === void 0 ? void 0 : flow.config) === null || _a === void 0 ? void 0 : _a.layout) === null || _b === void 0 ? void 0 : _b.navGroups })] }) })] }));
}
